import _ from './toolbar.module.scss'
import React from 'react'
import {$, $$$} from '../shared/class-name'
import {useSharedStore} from '../state/shared-store-context'
import {useLocation} from 'react-router-dom'
import {useHideAwarePosition} from '../hooks/use-hide-aware-position'
import {useMobileFirst} from '../hooks/use-mobile-first'
import {isProfilePath} from '../apps/outof195/shared/profile-url'

export const Toolbar = () => {
    const {sharedState} = useSharedStore()
    const location = useLocation()
    const {pathname: path} = location
    const mobileFirst = useMobileFirst()
    const isWhiteBorder = !path.includes('/rankings/') && !path.includes('/network/messages/')
    const toolbarHidden = (sharedState.toolbarContent === null || sharedState.scrolledPast320) && !sharedState.noHideToolbar
    const {position, flipVertically, hidden, noTransition, content, backdropFilterEnabled
    } = useHideAwarePosition(sharedState.floatingToolbarPosition, toolbarHidden, sharedState.toolbarContent,
        sharedState.flipToolbarVertically)
    const {pathname} = useLocation()

    return <div className={$$$(
        $(_.root),
        $(_.mobileFirst, mobileFirst),
        $(_.hidden, hidden),
        $(_.noTransition, noTransition),
        $(_.floating, sharedState.floatingToolbar),
        $(_.flipVertically, flipVertically),
        $(_.whiteBorder, isWhiteBorder && !flipVertically),
        $(_.left, position === 'left'),
        $(_.right, position === 'right'),
        $(_[`_${sharedState.toolbarColumnCount || 5}columns`]),
        $(_.profile, isProfilePath(pathname)),
        $(_.rankings, pathname.includes('/rankings/')),
        $(_.backdropFilterEnabled, backdropFilterEnabled),
    )} data-layout="toolbar">
        <div className={_.content}>
            {content}
        </div>
    </div>
}
